import React from 'react';
import { Stack, useTheme } from '@mui/material';
import { VTypography } from '@venti-components';

const CardField = ({ title, textValue, componentValue }) => {
  const theme = useTheme();
  return (
    <Stack flex={1}>
      <VTypography color={theme.palette.text.secondary} variant="caption">
        {title}
      </VTypography>
      {componentValue || <VTypography variant="body2">{textValue}</VTypography>}
    </Stack>
  );
};

export default CardField;
